import {RequestInfo} from "@khan/shared-core";

import {optOutCountries} from "./constants.ts";
import {CookieCategory} from "./types.ts";

/**
 * Default cookie consent
 *
 * This function provides the default cookie consent for situations where the
 * user hasn't explicitly consented to any cookies.
 *
 * @return {ReadonlyMap<CookieCategory, boolean>} A map indicating the default
 * consent status for each cookie category.
 */
export const defaultCookieConsent = function (): ReadonlyMap<
    CookieCategory,
    boolean
> {
    // sync-start:default-cookie-consent 1161250384 https://github.com/Khan/webapp/blob/master/pkg/web/cookie_consent.go
    if (
        optOutCountries.some((country) => RequestInfo.remoteCountry === country)
    ) {
        return new Map([
            [CookieCategory.StrictlyNecessary, true],
            [CookieCategory.Performance, true],
            [CookieCategory.Functional, true],
            [CookieCategory.Targeting, false],
        ]);
    }

    return new Map([
        [CookieCategory.StrictlyNecessary, true],
        [CookieCategory.Performance, false],
        [CookieCategory.Functional, false],
        [CookieCategory.Targeting, false],
    ]);
    // sync-end:default-cookie-consent
};
